import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Input, InputBase } from "@material-ui/core/";
import Slider from "@material-ui/core/Slider";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 240,
    // color: "red",
    marginLeft: "2rem",
    display: "flex",
  },
  margin: {
    // height: theme.spacing(4),
  },
  track: {
    backgroundColor: "black",
    height: "1rem",
  },
  rail: {
    backgroundColor: "silver",
    height: "1rem",
    // width: "3rem",
  },
  thumb: {
    color: "#F630A9",
    width: "2rem",
    height: "2rem",
  },
  input: {
    // height: (props) => (props.height ? props.height : 40),
    padding: "8px 1.2rem",
    // border: "1px solid black",
    display: "flex",
    alignItems: "center",
    fontSize: "1.4rem",
    marginLeft: "2rem",
    // lineHeight: "2.4rem",
    // backgroundColor:"silver",
    borderRadius: "12px",
    fontWeight: "400",
    width: "fit-content",
    marginTop: "-2.2rem",
    // width: (props) => (props.width ? `${props.width / 10}rem` : "100%"),
  },
}));

function valuetext(value) {
  return `${value}°C`;
}
export default function DiscreteSlider({ value, setValue, maxValue }) {
  const classes = useStyles();
  const marks = [
    {
      value: 0,
      label: "Min",
    },

    {
      value: maxValue,
      label: "Max",
    },
  ];

  return (
    <div className={classes.root}>
      <Slider
        style={{ paddingTop: "7px" }}
        classes={{
          track: classes.track,
          rail: classes.rail,
          thumb: classes.thumb,
        }}
        defaultValue={40}
        getAriaValueText={valuetext}
        valueLabelDisplay="auto"
        aria-labelledby="discrete-slider-always"
        step={1}
        marks={marks}
        max={maxValue}
        value={value}
        onChange={(e, v) => {
          {
            setValue(v);
            console.log("VALUE---------------------------", v);
          }
        }}
      />
      <InputBase
        className={classes.input}
        inputProps={{ maxlength: 88 }}
        value={value}
        onChange={(e) => {
          e.target.value <= maxValue
            ? setValue(e.target.value)
            : setValue(maxValue);
        }}
        placeholder={40}
        // multiline={height}
        // type={type}
      />
    </div>
  );
}
